import * as React from 'react';

import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import { EMainMenuCounters, EStore } from '@enums';

import { counters } from '@utils';

import { AppsStore, CurrentUserStore, MainMenuAppsStore, UiStore } from '@stores';

import { Api } from '@api';

import { usePreventScroll, useTouchMenu } from './hooks';
import { MainMenuView } from './MainMenuView';

import s from './MainMenu.scss';

export interface IMainMenuProps {
	className?: string;
	currentUserStore?: CurrentUserStore;
	mainMenuAppsStore?: MainMenuAppsStore;
	appsPopularStore?: AppsStore;
	uiStore?: UiStore;
}

export const MainMenu = inject(
	EStore.UI,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
	EStore.APPS_POPULAR,
)(observer((
	{
		currentUserStore,
		mainMenuAppsStore: { myApps, suggestApps },
		uiStore,
		appsPopularStore,
		uiStore: {
			slidingMenu: { isVisible: slidingMenuIsVisible = false },
		},
	}: IMainMenuProps,
) => {
	const [isLoadedLeftMenu, setIsLoadedLeftMenu] = React.useState(false);
	const mainMenuViewRef = React.useRef<HTMLDivElement>(null);

	const hideMenu = function() {
		uiStore.toggleSlideMenu(false);
	};

	const onLogin = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		counters.sendRB(EMainMenuCounters.LOGIN);
		Api.currentUser.logIn();
	};

	const onRegistration = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		counters.sendRB(EMainMenuCounters.REGISTRATION);
		Api.currentUser.registration();
	};

	const onLogout = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		currentUserStore.logout();
		counters.sendRB(EMainMenuCounters.LOGOUT);
		Api.currentUser.logout();
	};

	const onLeftMenuLoad = () => setIsLoadedLeftMenu(true);

	useTouchMenu({
		mainMenuViewRef,
		hideMenu,
	});

	if (!IS_SSR) {
		usePreventScroll({
			isDisableScroll: slidingMenuIsVisible,
			isDOMReady: isLoadedLeftMenu,
		});
	}

	const props = {
		mainMenuViewRef: mainMenuViewRef,
		isVisible: slidingMenuIsVisible,
		currentUser: currentUserStore.currentUser,
		menuApps: { myApps, suggestApps },
		onHide: hideMenu,
		onLogOutClick: onLogout,
		onLogInClick: onLogin,
		onRegistrationClick: onRegistration,
		onLeftMenuLoad: onLeftMenuLoad,
	};

	return <div>
		<MainMenuView {...props}/>

		<div className={classNames(s.overlay, { [s.visible]: slidingMenuIsVisible })}
			onClick={hideMenu}
		/>
	</div>;
}));
